module.exports = __webpack_public_path__ + "static/media/empty-star.abc70e23.svg";